<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-za-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-za-badge">ZigZag Heading + Secondary CTA</span>

  <div class="cr-za-row">
    <div
      class="cr-za-dropzone"
      [appInlineMedia]="block.variables?.['ZigZagHaacImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'ZigZagHaacImage')"
    >
      <a *ngIf="block.variables?.['ZigZagHaacImage']; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['ZigZagHaacImage']" [alt]="block.variables?.['ZigZagHaacImageAlt'] || ''" />
      </a>

      <ng-template #emptyPreview>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div class="cr-za-content">
      <span
        class="cr-za-heading"
        [appInlineEdit]="block.variables?.ZigZagHaacHeading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'ZigZagHaacHeading')"
      ></span>

      <span
        class="cr-za-text"
        [appInlineEdit]="block.variables?.ZigZagHaacText ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert row text"
        [inlineEditMultiline]="true"
        (inlineEditChange)="onChange($event, 'ZigZagHaacText')"
      ></span>

      <a class="cr-za-cta" [href]="ctaPreviewHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.ZigZagHaacCtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'ZigZagHaacCtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form -->
<div class="cr-za-edit" *ngIf="!isPreview">
  <div class="cr-za-field-row">
    <span class="cr-za-field-label">Image</span>
    <span
      class="cr-za-toggle"
      [class.cr-za-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-za-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['ZigZagHaacImage'] ?? ''"
      (handleOnChange)="onChange($event, 'ZigZagHaacImage')"
      [placeholder]="imagePlaceholder"
      variable="ZigZagHaacImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-za-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['ZigZagHaacImage']">
      <div class="cr-za-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-za-title">Upload image</div>
      <div class="cr-za-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-za-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['ZigZagHaacImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'ZigZagHaacImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="ZigZagHaacImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagHaacImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['ZigZagHaacImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['ZigZagHaacImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagHaacImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="ZigZagHaacImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['ZigZagHaacHeading'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagHaacHeading')"
    [placeholder]="headingPlaceholder"
    [maxLength]="500"
    variable="ZigZagHaacHeading"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['ZigZagHaacText'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagHaacText')"
    [placeholder]="textPlaceholder"
    [maxLength]="4000"
    variable="ZigZagHaacText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-za-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['ZigZagHaacCtaLink'] ?? ''"
      (handleOnChange)="onChange($event, 'ZigZagHaacCtaLink')"
      [placeholder]="ctaLinkPlaceholder"
      [maxLength]="500"
      variable="ZigZagHaacCtaLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagHaacCtaLinkSegmentRegex')"
      [selectedSegment]="block.variables?.['ZigZagHaacCtaLinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['ZigZagHaacCtaText'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagHaacCtaText')"
    [placeholder]="ctaTextPlaceholder"
    [maxLength]="30"
    variable="ZigZagHaacCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
